<template>
  <div>
    <remote-css :href="require('@/assets/mui/css/mui.css')"></remote-css>
    <remote-css :href="require('@/assets/app/css.css')"></remote-css>
    <remote-css :href="require('@/assets/mui/css/mui.css')"></remote-css>
    <remote-css :href="require('@/assets/mui/css/style.css')"></remote-css>
    <div id="mapDiv" style="width: 100%;height: 100%;background-color: #000000;position: absolute;">
      　　<p id="allmap" style="width: 100%;height: 100%;"></p>
    </div>

    <div class="dh_btn" @click="goMap()">
      <i class="iconfont icon-weizhi"></i>地图导航
    </div>
    <!-- 打开actionsheet按钮，弹出拍照功能 -->
    <div id="sheet1" class="mui-popover mui-popover-bottom mui-popover-action ">
      <!-- 可选择菜单 -->
      <ul class="mui-table-view">
        <li class="mui-table-view-cell">
          <a href="#" @click="gaodeToMap()">高德地图</a>
        </li>
        <li class="mui-table-view-cell">
          <a href="#" @click="baiduToMap()">百度地图</a>
        </li>
      </ul>
      <!-- 取消菜单 -->
      <ul class="mui-table-view">
        <li class="mui-table-view-cell">
          <a href="#sheet1"><b>取消</b></a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    name: "maps",
    data() {
      return {
        model: {
          imagelist: []
        },
        lng: '',
        lat: '',
        toLng:"",
        toLat:"",
        buttons:[
                  {title:'高德地图',extra:{scene:'gaodeMap'}},
                  {title:'百度地图',extra:{scene:'baiduMap'}}
                ]
      }
    },
    methods: {
      getLocation() {
        var that = this;
        plus.geolocation.getCurrentPosition(that.showPosition, that.showError); //h5+获取定位的经纬度,获取成功则调用showPosition,失败则调用showError.
      },
      showPosition(position) {
        var that = this;
        that.lng = position.coords.longitude; //经度
        that.lat = position.coords.latitude; //纬度
        console.log("position:");
        console.log(position);
      },
      showError(error) {
        switch (error.code) {
          case error.PERMISSION_DENIED:
            alert("定位失败,用户拒绝请求地理定位");
            break;
          case error.POSITION_UNAVAILABLE:
            alert("定位失败,位置信息是不可用");
            break;
          case error.TIMEOUT:
            alert("定位失败,请求获取用户位置超时");
            break;
          case error.UNKNOWN_ERROR:
            alert("定位失败,定位系统失效");
            break;
        }
      },
      showBaiDuMap(lng, lat) {
        var that = this;
        // 百度地图API功能
        //地图初始化
        var map = new BMap.Map("allmap");
        var gpsPoint = new BMap.Point(lng, lat);
        map.centerAndZoom(gpsPoint, 18);

        //设置定位按钮位置
        var opts = {
          anchor: BMAP_ANCHOR_BOTTOM_RIGHT
        }
        //将定位控件添加到地图上
        map.addControl(new BMap.GeolocationControl(opts));
        //设置缩放按钮位置及类型
        var ove = {
          anchor: BMAP_ANCHOR_TOP_RIGHT,
          type: BMAP_NAVIGATION_CONTROL_ZOOM
        }
        //添加缩放按钮
        map.addControl(new BMap.NavigationControl(ove));
        var geolocation = new BMap.Geolocation();

        //坐标转换完之后的回调函数
        translateCallback = function(data) {
          plus.nativeUI.closeWaiting(); //关闭等待动画
          if (data.status === 0) {
            var new_point = data.points[0]; //这是转换后的百度坐标
            var marker = new BMap.Marker(new_point);
            map.addOverlay(marker);

            map.centerAndZoom(new_point, 20);
            map.panTo(new_point); //地图中心移动到定位的点

            var gc = new BMap.Geocoder();
            gc.getLocation(new_point, function(rs) {
              var addComp = rs.addressComponents;
              console.log(rs.address); //地址信息


            });
          }
        }
        setTimeout(function() {
          var convertor = new BMap.Convertor();
          var pointArr = [];
          pointArr.push(gpsPoint);
          //将gps定位坐标转为百度定位坐标,转换成功后调用回调函数translateCallback.
          convertor.translate(pointArr, 1, 5, translateCallback)
        }, 1000);
      },
      /**
       * 开始导航
       */
      goMap() {
        // var that=this;
        // plus.nativeUI.actionSheet({cancel:'取消',buttons:that.buttons}, function(e){
        //   if(that.buttons[e.index-1].title=="高德地图"){
        //       that.gaodeToMap();
        //   }else{
        //       that.baiduToMap();
        //   }
        // });
          mui('#sheet1').popover('toggle');

          this.loadconfig();
      },
      gaodeToMap(){

        var that=this;
         var name=this.$app.getParam("name")

         if(that.$store.state.config.jtype)//判断是否是苹果手机
         {
           var iosGaode=encodeURI("iosamap://path?sourceApplication=云学员一点通&did=&dlat="+this.$app.getParam('lat')+"&dlon="+this.$app.getParam('lng')+"&dname="+name+"&dev=0&t=0");
             location.href=iosGaode;
           // plus.runtime.openURL(iosGaode);
         }else{
           var androidGaode=encodeURI("amapuri://route/plan/?sourceApplication=云学员一点通did=&dlat="+this.$app.getParam('lat')+"&dlon="+this.$app.getParam('lng')+"&dname="+name+"&dev=0&t=0");
             alert(androidGaode)
           location.href=androidGaode;
           // plus.runtime.openURL(androidGaode);
         }
      },
      baiduToMap(){
        var that=this;
        var name=this.$app.getParam("name")
        if(that.$store.state.config.jtype)//判断是否是苹果手机
        {
          var iosBaidu=encodeURI("baidumap://map/marker?location="+this.toLat+","+this.toLng+"&title="+name+"&content="+name+"&&traffic=on&src=ios.app.ioccn.com");
            location.href=iosBaidu;
          //plus.runtime.openURL(iosBaidu);
        }else{
          var androidBaidu=encodeURI("bdapp://map/marker?location="+this.toLat+","+this.toLng+"&title="+name+"&content="+name+"&traffic=on&src=andr.app.ioccn.com");
            location.href=androidBaidu;
          // plus.runtime.openURL(androidBaidu);
        }
      },
      loadconfig(){
          var that = this

          var options = this.$route.query;
          this.$app.pr('/api/common/jsapi_openLocation',{
              url:that.$wx.getUrls()
          }).then((res) => {
              wx.config(res.data.shareparam);
              try{
                  wx.ready(function(){
                      wx.openLocation({
                          latitude: 22.545538, // 纬度，浮点数，范围为90 ~ -90
                          longitude: 114.054565, // 经度，浮点数，范围为180 ~ -180。
                          name: '这里填写位置名', // 位置名
                          address: '位置名的详情说明', // 地址详情说明
                          scale: 10, // 地图缩放级别,整形值,范围从1~28。默认为最大
                      });
                  });
              }catch(e){alert('fx error'+e)}
          });
      }
    },
    created() {
      this.getLocation();
    },
    mounted() {
      var  that=this;
      var lng = this.$app.getParam('lng');
      var lat = this.$app.getParam('lat');
      //腾讯地图坐标转百度地图坐标
      if (lng == null || lng == '' || lat == null || lat == '' || lng == 0 || lat == 0) {
        lng = 102.714601139;
        lat = 25.0491531005;
      } else {
        var x_pi = 3.14159265358979324;
        var x = parseFloat(lng);
        var y = parseFloat(lat);
        var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * x_pi);
        var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * x_pi);
        lng = (z * Math.cos(theta) + 0.0065).toFixed(5);
        lat = (z * Math.sin(theta) + 0.006).toFixed(5);
      }
      that.toLng=lng;
      that.toLat=lat;


      //地图初始化
      var map = new BMap.Map("allmap");
      var gpsPoint = new BMap.Point(lng, lat);
      map.centerAndZoom(gpsPoint, 16);

      if (!(this.$app.getParam('lng') == null || this.$app.getParam('lng') == '' || this.$app.getParam('lng') == 0)) {
        var mk = new BMap.Marker(gpsPoint);
        map.addOverlay(mk);
        map.panTo(gpsPoint);
      }

      //设置缩放按钮位置及类型
      var ove = {
        anchor: BMAP_ANCHOR_TOP_RIGHT,
        type: BMAP_NAVIGATION_CONTROL_ZOOM
      }
      //添加缩放按钮
      map.addControl(new BMap.NavigationControl(ove));
    }
  }
</script>

<style>
  .BMap_stdMpType4 .BMap_stdMpZoom {
    top: 1.14rem !important;
  }

  .dh_btn {
    position: absolute;
    bottom: .5rem;
    width: 90%;
    left: 50%;
    transform: translateX(-50%);
    background-color: #2AAFFB;
    border-radius: .1rem;
    line-height: .88rem;
    color: #fff;
    font-size: .28rem;
    text-align: center;
  }

  .dh_btn i {
    margin-right: .2rem;
    font-size: .28rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/Map.vue